import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import PropTypes from "prop-types";
import { DownloadDepartmentAPI } from "../../../../services/api/department-api";
import { DownloadRolesNew } from "../../../../services/api/role-api";
import { DownloadUsersNew } from "../../../../services/api/user-api";
import { LoginContext } from "../../../../services/api/authentication-api";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUser } from "../../../../redux/user/user-selector";
import { PulseLoader } from "react-spinners";
import "./adminDownload.scss";
import "../../../tasks/scenes/tasks-comments/shared-modal-header.scss";
import { DownloadGroupsAPI } from "../../../../services/api/group-api";

const AdminDownloadConfirmPopupNew = ({ type, onHide, show, button }) => {
  const [config, setConfig] = useState({
    type: "",
    loading: false,
  });

  useEffect(() => {
    setConfig((prev) => ({
      ...prev,
      type:
        type === "department"
          ? "departments"
          : type === "log-activity"
          ? "Log Activity"
          : type,
    }));
  }, []);

  const submitAction = async () => {
    let downloadFunc;
    try {
      switch (type) {
        case "group":
          downloadFunc = DownloadGroupsAPI;
          break;
        case "department":
          downloadFunc = DownloadDepartmentAPI;
          break;
        case "roles":
          downloadFunc = DownloadRolesNew;
          break;
        case "users":
          downloadFunc = DownloadUsersNew;
          break;
        default:
          break;
      }
      setConfig((prev) => ({ ...prev, loading: true }));
      let result = await downloadFunc();
      const link = document.createElement("a");
      link.href = result.data;
      link.download = "filename";
      link.click();
      setConfig((prev) => ({ ...prev, loading: false }));
      onHide();
    } catch (error) {
      onHide();
    }
  };

  return (
    <LoginContext.Consumer>
      {(state) => (
        <div onClick={(e) => e.stopPropagation()}>
          <Modal show={show} onHide={onHide} className="tasks-actions-popup">
            <div className="admin-actions">
              <Modal.Header className="header-popup" closeButton>
                <Modal.Title className="actions-title">
                  Download {config.type}
                </Modal.Title>
              </Modal.Header>
              <div className="select-member-divider-line"></div>
              {config.loading === true ? (
                <div style={{ padding: "50px 100px", textAlign: "center" }}>
                  <PulseLoader></PulseLoader>
                </div>
              ) : (
                <Modal.Body className="header-body">
                  <h3 className="actions-task-name">Download {config.type}?</h3>
                  <Button
                    className="btn-wide"
                    onClick={submitAction}
                    variant="primary"
                  >
                    {button}
                  </Button>

                  {button === "Cancel" ? (
                    <Button
                      className="btn-wide btn-outlined"
                      onClick={onHide}
                      variant="primary"
                    >
                      Back
                    </Button>
                  ) : (
                    <Button
                      className="btn-wide btn-outlined"
                      onClick={onHide}
                      variant="primary"
                    >
                      Cancel
                    </Button>
                  )}
                </Modal.Body>
              )}
            </div>
          </Modal>
        </div>
      )}
    </LoginContext.Consumer>
  );
};

const mapState = createStructuredSelector({
  currentUser: selectUser,
});

AdminDownloadConfirmPopupNew.propTypes = {
  show: PropTypes.bool.isRequired,
  button: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onHide: PropTypes.func.isRequired,
};
AdminDownloadConfirmPopupNew.contextType = LoginContext;
export default connect(mapState, null)(AdminDownloadConfirmPopupNew);
